import { render, staticRenderFns } from "./MenuTabs.vue?vue&type=template&id=58e85d38&scoped=true&"
import script from "./MenuTabs.vue?vue&type=script&lang=js&"
export * from "./MenuTabs.vue?vue&type=script&lang=js&"
import style0 from "./MenuTabs.vue?vue&type=style&index=0&id=58e85d38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e85d38",
  null
  
)

export default component.exports